
/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class BlacklistItemValidityDtoModel{
  uuid: string | null | undefined = undefined;
  comment: string | null | undefined = undefined;
  lastModifiedByEmployeeName: string | null | undefined = undefined;
  validFrom: string | null = null;
  validTo: string | null = null;
}
